import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../components/styles/onboardingLoadingPage.scss";

/**
 * OnboardingLoadingPage — "This may take a moment" (Final onboarding step)
 * Figma: 1.7 Onboarding(Desktop) (24654:6064)
 *
 * Layout: Full-screen dark page (NO sidebar stepper)
 *   - Background: grid pattern with subtle glow at bottom center
 *   - Centered content:
 *     - Spinner (loading arc, white)
 *     - Title: "This may take a moment" (Poppins SemiBold, white)
 *     - Subtitle: "We are personalizing your account..." (Poppins Regular, #a3a3a3)
 *   - Auto-navigates to /home after processing
 */
const OnboardingLoadingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate processing, then navigate to home
    const timer = setTimeout(() => {
      navigate("/home");
    }, 4000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="onboarding-loading">
      {/* Background pattern */}
      <div className="onboarding-loading__bg">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="loading-grid" width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M 80 0 L 0 0 0 80" fill="none" stroke="#1a1a1e" strokeWidth="0.5" />
            </pattern>
            <radialGradient id="bottom-glow" cx="50%" cy="85%" r="35%">
              <stop offset="0%" stopColor="#262626" stopOpacity="0.3" />
              <stop offset="100%" stopColor="transparent" />
            </radialGradient>
          </defs>
          <rect width="100%" height="100%" fill="url(#loading-grid)" />
          <rect width="100%" height="100%" fill="url(#bottom-glow)" />
          {/* Dot accents */}
          <circle cx="10%" cy="8%" r="2" fill="#404040" opacity="0.5" />
          <circle cx="35%" cy="12%" r="2" fill="#404040" opacity="0.5" />
          <circle cx="20%" cy="85%" r="2" fill="#404040" opacity="0.5" />
          <circle cx="8%" cy="70%" r="2" fill="#404040" opacity="0.5" />
        </svg>
      </div>

      {/* Centered content */}
      <div className="onboarding-loading__content">
        {/* Spinner */}
        <div className="onboarding-loading__spinner" />

        {/* Title */}
        <h1 className="onboarding-loading__title">This may take a moment</h1>

        {/* Subtitle */}
        <p className="onboarding-loading__subtitle">
          We are personalizing your account to recommend movies according to
          your preferences
        </p>
      </div>
    </div>
  );
};

export default OnboardingLoadingPage;
